import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Component, Inject, Injector, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Calendar, UserContactIds, Contact, ProgramCategoryListModel, BrandInfoModel } from '../model/appointment.model';
import { LoadingService } from '../service/loading.service';
import { BrandService } from '../service/brand.service';
import { Subject, finalize } from 'rxjs';
import { AppointmentService } from '../appointment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-appointment-empty',
  templateUrl: './appointment-empty.component.html',
  styleUrls: ['../appointment/appointment.component.css', './appointment-empty.component.css']
})
export class AppointmentEmptyComponent implements OnInit {
  public model: Calendar;
  public contact: Contact;
  public categories: ProgramCategoryListModel[];
  public step: number;
  public loading: boolean;
  public completed: boolean;
  public brandId: number;
  public french: boolean;
  public brandSubject: Subject<void> = new Subject<void>();
  public bookingTitle: string;
  public apptWithSubtitle: string;
  public sourceId: string;
  public errorSourceId: string;
  public submissionError = '';
  public submitting = false;
  public hasShift = true;

  constructor(private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private brandService: BrandService,
    private appointmentService: AppointmentService,
    private router: Router,
    private renderer: Renderer2,
    private translate: TranslateService) {
    this.french = this.brandService.inFrench();
    this.brandId = this.brandService.checkBrand(this.route.snapshot.params);
    this.loadingService.setColor(this.brandId.toString());
    this.loadingService.show();

    const queryString = window.location.search;
    this.setCookie("lc_appointment_params", queryString, 30);
    const urlParams = new URLSearchParams(queryString);
    this.bookingTitle = urlParams.get('booking-title');

    if (!this.bookingTitle) {
      this.bookingTitle = this.french ? "Prendre rendez-vous avec le responsable des admissions" : "Book an Appointment with Admission Representative";
    }

    this.apptWithSubtitle = this.french ? "Veuillez indiquer votre courriel dans le champ ci-dessous pour prendre rendez-vous" : "Please provide your email in the field below to book an appointment";

  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.sourceId = params.sourceId;
      //this.setBackground(this.brandId);
    });

    this.step = 1;
    this.loading = false;
    this.http.get<BrandInfoModel>(this.baseUrl + 'Appointment/GetBrandInfo/' + this.brandId).subscribe(response => {
      this.model = response.model;
      this.setBackground(this.brandId);
      this.categories = response.categories;
      this.loadingService.hide();
      var brandSubject = this.brandSubject;
      setTimeout(function () { brandSubject.next(); }, 100);

      this.brandService.setTitle(this.model.brandId, this.model.brandName);
      this.completed = true;

      this.hasShift = this.appointmentService.hasShift;
      this.appointmentService.hasShift = true;
    }, error => {
      console.log(error);
    });
  }

  setBackground(brandId: number): void {
    const body = document.querySelector('body');
    if (body) {
      if (brandId === 543) {
        this.renderer.setStyle(body, 'background', 'linear-gradient(180deg, #000 6.33%, #343434 93.63%), #333');
      } else {
        this.renderer.setStyle(body, 'background', '#FFF');
      }
    }
  }

  getCalendar() {
    if (this.inviteInvalid())
      return;
    //this.loading = true;
    this.loadingService.show();

    const queryString = window.location.search;
    this.setCookie("lc_appointment_params", queryString, 30);

    this.http.post<UserContactIds>(this.baseUrl + 'Appointment/GetByEmail/', this.model).subscribe(response => {
      if (this.model.brandId == response.brandId) {
        var userID = response.userId;
        if (userID !== undefined && userID !== null && userID > 0)
          this.router.navigateByUrl(`appointment/${response.userId}/${response.contactId}`);
        else
          this.router.navigateByUrl(`${response.contactId}`);
      }
      /*LC-871 --- START ---*/
      else {
        this.gotoInfoForm2();
        this.contact.email = this.model.email;
        this.loadingService.hide();

        switch (this.model.brandId) {
          case 372:
            window.location.href = "https://www.career.college/thank-you/";
            break;
          case 373:
            window.location.href = this.french ? "https://www.collegecdi.ca/colombie-britannique/merci/" : "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/"
            break;
          case 374:
            window.location.href = "https://www.reevescollege.ca/thank-you/";
            break;
          case 543:
            window.location.href = "https://www.vcad.ca/thank-you/";
            break;
          case 500:
            window.location.href = "https://www.tkc.edu/thank-you/";
            break;
          default:
            window.location.href = "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/?done"
            break;
        }
      }
      /*LC-871 --- END ---*/

      if (this.model.brandId2 == response.brandId2) {
        this.gotoInfoForm2();
        this.contact.email = this.model.email;
        this.loadingService.hide();
      } else {
        this.gotoInfoForm();
        this.contact.email = this.model.email;
        //this.loading = false;
        this.loadingService.hide();
      }
    }, error => {
      console.log(error);
      this.gotoInfoForm();
      this.contact.email = this.model.email;
      //this.loading = false;
      this.loadingService.hide();
    });
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  private setCookie(name: string, value: string, expireMinutes: number, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireMinutes * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  private deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  gotoInfoForm() {
    if (!this.contact)
      this.contact = { brandId: this.model.brandId, firstname: '', lastname: '', email: '', phone: '', postcode: '', program: 0, sourceId: '' };
    this.step = 2;
  }

  gotoInfoForm2() {
    if (!this.contact)
      this.contact = { brandId: this.model.brandId, firstname: '', lastname: '', email: '', phone: '', postcode: '', program: 0, sourceId: '' };
    this.step = 3;
  }

  cancelInfoForm() {
    this.step = 1;
  }

  submitInfoForm() {
    if (this.submitting) {
      return;
    }

    this.submissionError = '';
    this.errorSourceId = '';

    if (this.sourceId !== undefined) {
      this.contact.sourceId = this.sourceId.replace(/S/g, '');
      if (!/^\d+$/.test(this.contact.sourceId)) {
        this.errorSourceId = 'Sorry, the prefix sourceID is invalid.';
        return;
      }
    }

    this.submitting = true;
    this.loadingService.show();

    this.http.post<UserContactIds>(this.baseUrl + 'Appointment/SubmitContact', this.contact)
      .pipe(finalize(() => {
        this.submitting = false;
        this.loadingService.hide();
      }))
      .subscribe({
        next: response => {
          if (!response || !(response.contactId > 0) || !(response.userId >= 0)) {
            this.showSubmissionError();
            return;
          }

          this.router.navigateByUrl(`appointment/${response.userId}/${response.contactId}`)
            .then(navigated => {
              if (!navigated) {
                this.showSubmissionError();
              }
            })
            .catch(() => this.showSubmissionError());
        },
        error: response => this.showSubmissionError(response?.error?.error ?? response?.error?.Error)
      });
  }

  private showSubmissionError(reason?: string) {
    switch (reason) {
      case 'Invalid program.':
      case 'Program not offered':
      case 'Out of Area':
      case 'Out of area.':
        this.submissionError = this.french
          ? 'Ce programme n’est pas offert pour le code postal indiqué. Vérifiez votre code postal ou choisissez un autre programme.'
          : 'This program is not available for your postal code. Check your postal code or choose another program.';
        break;
      case 'Invalid postal code':
        this.submissionError = this.french
          ? 'Veuillez vérifier votre code postal.'
          : 'Please check your postal code.';
        break;
      case 'Invalid Phone':
      case 'International Phone Number':
        this.submissionError = this.french
          ? 'Veuillez vérifier votre numéro de téléphone.'
          : 'Please check your phone number.';
        break;
      default:
        this.submissionError = this.french
          ? 'Nous n’avons pas pu confirmer l’enregistrement de vos renseignements. Contactez le soutien avant de soumettre de nouveau.'
          : 'We could not confirm whether your information was saved. Contact support before submitting again.';
        break;
    }
  }

  inviteInvalid() {
    return !this.model.email || !this.model.email.includes('@') || !this.model.email.includes('.');
  }

  formInvalid() {
    return !this.contact.firstname || !this.contact.lastname || !this.contact.email || !this.contact.phone || this.contact.program == 0;
  }
}
